const productionLabels =
  Rails.helpers.currentConfiguration?.production_labels || {};

export const PRODUCTION_LABEL_OPTIONS = Object.entries(productionLabels).map(
  ([value, label]) => ({ value, label }),
);
